/**
 * ProjectsLogo
 *
 * The Access Projects product logo, inlined from public/assets/AppIcon.svg so
 * it renders crisply at any size without depending on a hosted asset path.
 */

interface ProjectsLogoProps {
  className?: string;
}

export function ProjectsLogo({ className }: ProjectsLogoProps) {
  return (
    <svg
      viewBox="0 0 513 513"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Projects logo"
    >
      <path d="M192 417V63L256 0L320 63V417H192Z" fill="#54B9B3" />
      <rect x="271.742" y="112" width="96" height="32" rx="16" transform="rotate(90 271.742 112)" fill="#2A5C59" />
      <path fillRule="evenodd" clipRule="evenodd" d="M512.191 128.254V256.254C512.191 397.639 397.576 512.254 256.191 512.254H255.191V384.254H256.191C326.884 384.254 384.191 326.946 384.191 256.254V128.254L448.191 64.2539L512.191 128.254Z" fill="#2A5C59" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 192.254V256.254C0 397.639 114.615 512.254 256 512.254H258V384.254H256C185.308 384.254 128 326.946 128 256.254V192.254L64 128.254L0 192.254Z" fill="#A0102C" />
      <rect x="41" y="255.627" width="32" height="32" transform="rotate(-45 41 255.627)" fill="#E5173F" />
      <rect x="426" y="255.627" width="32" height="32" transform="rotate(-45 426 255.627)" fill="#54B9B3" />
      <rect x="233" y="255.883" width="32" height="32" transform="rotate(-45 233 255.883)" fill="#DDF1F0" />
      <rect x="233" y="63.8867" width="32" height="32" transform="rotate(-45 233 63.8867)" fill="#2A5C59" />
      <rect x="426.191" y="127.887" width="32" height="32" transform="rotate(-45 426.191 127.887)" fill="#DDF1F0" />
      <circle cx="256" cy="448" r="64" fill="#4B112C" />
      <path d="M70.5603 305.905C78.7667 303.022 87.7443 307.225 90.8172 315.308L90.9597 315.697L91.5388 317.319C103.861 351.318 126.325 380.497 155.295 401.175C162.487 406.308 164.156 416.301 159.022 423.493C153.889 430.685 143.896 432.354 136.704 427.22C102.543 402.838 76.0209 368.415 61.4539 328.223L60.7683 326.304L60.6365 325.914C57.9769 317.684 62.3536 308.789 70.5603 305.905Z" fill="#E5173F" />
    </svg>
  );
}
